<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('appraisal management')"
      :columns="columns"
      :column_search="false"
      resource_url="/appraisal/appraisal/datatables"
      :extra_data="extra_filters"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="create_appraisal"
        >
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add appraisal") }}</span>
        </button>
      </template>
    </generic-table>

    <appraisal-modal ref="appraisal_modal" @success="refresh_datatable" />
    <appraisal-detail-modal
      ref="appraisal_detail_modal"
      @edit="edit_appraisal"
    />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date,
} from "@/utils";
import AppraisalModal from "./appraisal_modal/Index.vue";
import AppraisalDetailModal from "./appraisal_detail_modal/Index.vue";

export default {
  name: "AppraisalDataTable",
  components: {
    GenericTable,
    "appraisal-modal": AppraisalModal,
    "appraisal-detail-modal": AppraisalDetailModal,
  },
  data() {
    return {
      extra_filters: {},
      columns: [
        {
          title: this.$t("property address"),
          name: "property_address",
          searchable: true,
          width: "25%",
          data: (row) => {
            return `<div class="title is-6">${row.property_address || ""}</div>
                    <div class="subtitle is-7">${
                      row.property_type ? row.property_type.name : ""
                    }</div>`;
          },
        },
        {
          title: this.$t("price per sqm"),
          name: "price_per_sqm",
          width: "15%",
          data: (row) => {
            return format_currency(row.price_per_sqm || 0);
          },
        },
        {
          title: this.$t("total area"),
          name: "total_area",
          width: "12%",
          data: (row) => {
            return `${row.total_area || 0} m²`;
          },
        },
        {
          title: this.$t("valuation date"),
          name: "valuation_date",
          width: "15%",
          data: (row) => {
            return format_date(row.valuation_date);
          },
        },
        {
          title: this.$t("location"),
          width: "15%",
          data: (row) => {
            if (row.latitude && row.longitude) {
              return `<span class="tag is-success is-small">
                        <i class="fa fa-map-marker"></i>&nbsp;GPS
                      </span>`;
            }
            return `<span class="tag is-warning is-small">
                      <i class="fa fa-exclamation"></i>&nbsp;No GPS
                    </span>`;
          },
        },
        {
          title: this.$t("actions"),
          searchable: false,
          width: "18%",
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  v.$refs.appraisal_detail_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit_appraisal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  v.delete_appraisal(e.detail.uuid);
                },
              },
            ];

            if (row.latitude && row.longitude) {
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("show on map"),
                icon: "fa fa-map-marker",
                icon_class: "is-small has-text-success",
                click: function (e) {
                  // Future implementation: show on map
                  console.log("Show on map:", e.detail.uuid);
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create_appraisal() {
      this.$refs.appraisal_modal.show_modal();
    },

    edit_appraisal(uuid) {
      this.$refs.appraisal_modal.show_modal(uuid);
    },

    delete_appraisal(uuid) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure delete appraisal"), v, () => {
        del("/appraisal/appraisal", { uuid: uuid })
          .then(() => {
            v.refresh_datatable();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },

    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh_datatable();
  },
};
</script>
